import {
  CATALOG_TO_USER_EXCHANGE,
  positionSymbolToStockTicker,
  type StockInstrumentData,
  type StockVenueCode,
} from "@crypto-trading/common/browser";

export interface StockTradeTarget {
  symbol: string;
  displayTicker: string;
  allowedExchangeCodes: string[];
  symbolByExchangeCode: Record<string, string>;
}

function drawerSymbol(
  exchangeCode: StockVenueCode,
  symbol: string,
  ticker: string
): string {
  if (exchangeCode === "kucoin" || exchangeCode === "gate") {
    return `${ticker}USDT`;
  }
  return symbol;
}

export function buildStockTradeTarget(
  ticker: string,
  instruments: StockInstrumentData[]
): StockTradeTarget {
  const symbolByExchangeCode: Record<string, string> = {};
  const allowedExchangeCodes: string[] = [];

  for (const row of instruments) {
    if (row.ticker !== ticker) continue;
    const venue = row.exchangeCode as StockVenueCode;
    const userCode = CATALOG_TO_USER_EXCHANGE[venue];
    if (!userCode) continue;
    if (!allowedExchangeCodes.includes(userCode)) {
      allowedExchangeCodes.push(userCode);
    }
    symbolByExchangeCode[userCode] = drawerSymbol(venue, row.symbol, ticker);
  }

  const symbol =
    symbolByExchangeCode.binance ||
    symbolByExchangeCode.bybit ||
    symbolByExchangeCode.aster ||
    `${ticker}USDT`;

  return {
    symbol,
    displayTicker: ticker,
    allowedExchangeCodes,
    symbolByExchangeCode,
  };
}

export function isStockPosition(
  symbol: string,
  tickers: ReadonlySet<string>
): boolean {
  if (tickers.size === 0) return false;
  return tickers.has(positionSymbolToStockTicker(symbol));
}
